import React from 'react';

const CheckedCheckBox = ({width, height, color}) => {
    const getColor = (c) => {
        if (c === 'primary-500') return '#7F0689';
        if (c === 'secondary-500') return '#75D3A8';
        return c;
    };
    return (
        <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="20" height="20" fill="white"/>
            <path
                d="M2.5 6.23333C2.5 4.92654 2.5 4.27315 2.75432 3.77402C2.97802 3.33498 3.33498 2.97802 3.77402 2.75432C4.27315 2.5 4.92654 2.5 6.23333 2.5H12.7667C14.0735 2.5 14.7269 2.5 15.226 2.75432C15.665 2.97802 16.022 3.33498 16.2457 3.77402C16.5 4.27315 16.5 4.92654 16.5 6.23333V12.7667C16.5 14.0735 16.5 14.7269 16.2457 15.226C16.022 15.665 15.665 16.022 15.226 16.2457C14.7269 16.5 14.0735 16.5 12.7667 16.5H6.23333C4.92654 16.5 4.27315 16.5 3.77402 16.2457C3.33498 16.022 2.97802 15.665 2.75432 15.226C2.5 14.7269 2.5 14.0735 2.5 12.7667V6.23333Z"
                fill={getColor(color) || '#7F0689'} stroke={getColor(color) || '#7F0689'} strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M14 7L8.5 12L6 9.72727" stroke="white" strokeWidth="1.5" strokeLinecap="round"
                  strokeLinejoin="round"/>
        </svg>
    );
};
export default CheckedCheckBox;
